import {
  MDBAlert,
  MDBBtn,
  MDBCol,
  MDBSpinner,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { editIntegrations, getIntegrationDetail, getMisc } from "../../../apiclients/streamsapi_bridge";
import SaveChanges from "../../topviews/saveCancel";
import OutlookInt from "./OutlookInt";
import SalesForceInt from "./SalesForceInt";
import WebInt from "./WebInt";
import ZendeskInt from "./ZendeskInt";
import ZohoInt from "./ZohoInt";

export default function Integrations({ useragent, setEdited, isActive }) {
  const containerRef = useRef(null);
  const { t, i18n } = useTranslation();

  const zoho_docref = useRef(null);
  const sf_docref = useRef(null);
  const zdesk_docref = useRef(null);
  const wi_docref = useRef(null);
  const ol_docref = useRef(null);
  const navigate = useNavigate();
  const [rerender, setRerender] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [zohoMisc, setZohoMisc] = useState({});
  const [saleForceMisc, setSaleForceMisc] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [webIntegration, setwebIntegration] = useState({});
  const [outlookMisc, setOutlookMisc] = useState([]);

  const [activeTab, setaActiveTab] = useState("zoho");
const [allowScrollSpy, setAllowScrollSpy] = useState(false);

useEffect(() => {
  setaActiveTab("zoho");
  
  // Ensure Zoho becomes visible
  setTimeout(() => {
    zoho_docref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    setAllowScrollSpy(true);
  }, 300);
}, []);



  const { register, watch, getValues, setValue, formState: { isDirty, dirtyFields, errors }, handleSubmit, reset, clearErrors, setError } = useForm({
    defaultValues: {
      zoho: {
        enable_zoho: false,
        log_in_calls: true,
        log_out_calls: true,
        log_call_recording: true,
        log_call_transcription: true,
        ctc: 1,
        pstn_number: "",
      },
      zendesk: {
        enable_zendesk: false,
        open_ticket_on_in_calls: false,
        open_ticket_on_out_calls: true,
        auto_create_ticket: true,
      },
      salesforce: {
        enable_salesforce: false,
        ctc: "",
        username: "",
        password: "",
        log_in_calls: false,
        log_out_calls: false,
        auto_start_salesforce: false,
        auto_save_log_call: false
      },
      outlook: {
        enable_outlook: false,
        contacts_display: 50
      },
      web_integration: {
        web_is_enabled: false,
        is_active: [],
      }
    }
  });
  const activateTab = (value, targetRef, behavior = "smooth") => {
    if (value !== activeTab) {
      setaActiveTab(value);
    }
    if (targetRef?.current) {
      targetRef.current.scrollIntoView({
        behavior,
        block: "start"
      });
    }
  };

  useEffect(() => {
    if (!isActive) {
      return;
    }
    // force Zoho tab and scroll position whenever this view becomes active
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
    activateTab("zoho", zoho_docref, "auto");
  }, [useragent, rerender, isActive]);

  useEffect(() => {
    if (!isActive) {
      return;
    }
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const sections = [
      { key: "zoho", ref: zoho_docref },
      { key: "wievents", ref: wi_docref },
      { key: "sf", ref: sf_docref },
      { key: "zdesk", ref: zdesk_docref },
      { key: "outlook", ref: ol_docref }
    ];

    const handleScroll = () => {
      const scrollTop = container.scrollTop;
      let visibleTab = sections[0]?.key;
      sections.forEach((section) => {
        if (!section.ref.current) {
          return;
        }
        const relativeTop = section.ref.current.offsetTop - container.offsetTop;
        if (scrollTop >= relativeTop - 10) {
          visibleTab = section.key;
        }
      });
      if (visibleTab && visibleTab !== activeTab) {
        setaActiveTab(visibleTab);
      }
    };

    container.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [activeTab, isActive]);

  async function getIntegrationDetails() {
    try {
      setIsloading(true);
      const response = await getIntegrationDetail(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        useragent
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (!response) {
        return;
      }
      const integrationDetails = await response.json();
      console.log("getIntegrationDetail User integration settings ::: " + JSON.stringify(integrationDetails));
      setwebIntegration(integrationDetails?.webintegration ?? {});
      const integrations = {
        zoho: {
          enable_zoho: integrationDetails?.zoho?.enable_zoho ?? false,
          log_in_calls: integrationDetails?.zoho?.log_in_calls ?? false,
          log_out_calls: integrationDetails?.zoho?.log_out_calls ?? false,
          ctc: integrationDetails?.zoho?.ctc ? parseInt(integrationDetails?.zoho?.ctc) : 1,
          pstn_number: integrationDetails?.zoho?.pstn_number ?? " ",
          log_sms: integrationDetails?.zoho?.log_sms ?? false,
          log_call_recording: integrationDetails?.zoho?.log_call_recording ?? false,
          log_call_transcription: integrationDetails?.zoho?.log_call_transcription ?? false,
        },
        zendesk: {
          enable_zendesk: integrationDetails?.zendesk?.enable_zendesk ?? false,
          open_ticket_on_in_calls: integrationDetails?.zendesk?.open_ticket_on_in_calls ?? false,
          open_ticket_on_out_calls: integrationDetails?.zendesk?.open_ticket_on_out_calls ?? true,
          auto_create_ticket: integrationDetails?.zendesk?.auto_create_ticket ?? true,
        },
        salesforce: {
          enable_salesforce: integrationDetails?.salesforce?.enable_salesforce ?? false,
          ctc: integrationDetails?.salesforce?.ctc ? parseInt(integrationDetails?.salesforce?.ctc) : "6",
          username: integrationDetails?.salesforce?.username ?? "",
          password: integrationDetails?.salesforce?.password ?? "",
          log_in_calls: integrationDetails?.salesforce?.log_in_calls ?? false,
          log_out_calls: integrationDetails?.salesforce?.log_out_calls ?? false,
          auto_start_salesforce: integrationDetails?.salesforce?.auto_start_salesforce ?? false,
          auto_save_log_call: integrationDetails?.salesforce?.auto_save_log_call ?? false
        },
        outlook: {
          enable_outlook: integrationDetails?.outlook?.enable_outlook ?? false,
          contacts_display: integrationDetails?.outlook?.contacts_display ?? 50
        },
        web_integration: {
          web_is_enabled: integrationDetails?.webintegration?.web_is_enabled ?? false,
          is_active: [],
        }

      }

      reset(integrations);

    } catch (error) {

    }

  }

  useEffect(() => {
    if ((useragent !== "" || rerender) && isActive) {
      getIntegrationDetails();
      setRerender(false);
    }

  }, [useragent, rerender, isActive]);

  useEffect(() => {
    if (useragent !== ""  && isActive)
    getIntegrationMisc();

  }, [useragent, isActive]);

  async function getIntegrationMisc() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["zoho_integrations"],
      agentid: useragent
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + JSON.stringify(basicInfo));
    setZohoMisc(basicInfo?.misc?.zoho_integrations?.zohoDevices ?? {});
    setSaleForceMisc(basicInfo?.misc?.zoho_integrations?.salesforceDevices ?? {});
    setOutlookMisc(basicInfo?.misc?.zoho_integrations?.outlook_conatctslist ?? []);

  }

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  function closeSave(e) {
    reset();
  }

  const isSave =
    Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave);
  }, [isSave])

 
  const onSubmit = async (data) => {
    try {
      console.log(data)
      const modifiedData = {};
      const zohoData = { ...data.zoho };
     
      for (const field of Object.keys(dirtyFields)) {
       
        if (field === "zoho") continue;
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
  
            for (const subfield of Object.keys(dirtyFields[field])) {
              if (data[field].hasOwnProperty(subfield)) {
                modifiedData[field][subfield] = data[field][subfield];
              }
            }
          } else {
            modifiedData[field] = data[field];
          }
        }
      }

      if (!zohoData.pstn_number || zohoData.pstn_number.trim() === "") {
        delete zohoData.pstn_number;
      }
       modifiedData.reqid = 69;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.agentid = useragent;
     
      if(dirtyFields?.zoho && Object.keys(dirtyFields.zoho).length > 0) modifiedData.zoho = zohoData
      
      setIsloading(true);
      let saverep = await editIntegrations(modifiedData);
      console.log(`reponse of Edit integration:::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(
        "response of modified data :::" + JSON.stringify(saverepeMsg)
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
      } else {
        if (saverepeMsg?.message?.errors) {
          const errorArray = saverepeMsg.message.errors;

          errorArray.forEach((err) => {
            if (err.param_name && err.message) {
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });

              const fieldElement = document.querySelector(
                `[name="${err.param_name}"]`
              );
              if (fieldElement) {
                fieldElement.focus();
                fieldElement.scrollIntoView({ behavior: "smooth" });
              }
            }
          });
        }
         if(saverepeMsg?.message?.errors){
          saverepeMsg?.message.errors.forEach((errorGroup) => {
            if (errorGroup.errors) {
              errorGroup.errors.forEach((err) => {
                setError(err.param_name, {
                  type: "server",
                  message: err.message,
                });

                const fieldElement = document.querySelector(
                  `[name="${err.param_name}"]`
                );
                if (fieldElement) {
                  fieldElement.focus();
                  fieldElement.scrollIntoView({ behavior: "smooth" });
                }
              });
            }
          });
        }
      }
    } catch (error) {
      console.log(error)
    }
  }


  function updateWebIntEventActive(modifiedField) {
    setValue("web_integration.is_active", modifiedField, { shouldDirty: true });

  }

  return (
    <>
      <div className="row">
        <MDBCol
          size="2"
          md="2"
          lg="2"
          sm="12"
          className="col-sm-100 pr-0 leftTabs"
        >
          <MDBTabs className="flex-column text-center">
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => activateTab("zoho", zoho_docref)}
                active={activeTab === "zoho"}
              >
                {t("Zoho")}
              </MDBTabsLink>
            </MDBTabsItem>
            {/* <MDBTabsItem>
              <MDBTabsLink
                onClick={() => activateTab("sf", sf_docref)}
                active={activeTab === "sf"}
              >
                {t("SalesForce")}
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => activateTab("zdesk", zdesk_docref)}
                active={activeTab === "zdesk"}
              >
                {t("Zendesk")}
              </MDBTabsLink>
            </MDBTabsItem> */}
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => activateTab("wievents", wi_docref)}
                active={activeTab === "wievents"}
              >
                {t("WebInt")}
              </MDBTabsLink>
            </MDBTabsItem>
            {/* <MDBTabsItem>
              <MDBTabsLink
                onClick={() => activateTab("outlook", ol_docref)}
                active={activeTab === "outlook"}
              >
                {t("Outlook")}
              </MDBTabsLink>
            </MDBTabsItem> */}
          </MDBTabs>
        </MDBCol>
        <MDBCol
          size="12"
          md="10"
          sm="12"
          pr-0
          className="col-sm-100 pr-0 leftTabContent"
        >
          <div className="vtabHeight">
            <div className="w-95">
              <div
                id="element"
                ref={containerRef}
                className="scrollspy-example"
              >
              <section ref={zoho_docref} id="section-1">
                  <ZohoInt
                    zohoMisc={zohoMisc}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    getValues={getValues}
                    errors={errors}
                  />
                </section>
                {/* <section ref={sf_docref} id="section-2">
                  <SalesForceInt
                    saleForceMisc={saleForceMisc}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    getValues={getValues}
                    errors={errors}
                  />
                </section>
                <section ref={zdesk_docref} id="section-3">
                  <ZendeskInt
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    getValues={getValues}
                    errors={errors}
                  />
                </section> */}
                <section ref={wi_docref} id="section-4">
                  <WebInt
                    webIntegration={webIntegration}
                    setwebIntegration={setwebIntegration}
                    useragent={useragent}
                    updateWebIntEventActive={updateWebIntEventActive}
                    register={register}
                    parentWatch={watch}
                    parentreset={reset}
                    setRerender={setRerender}
                    setSuccessMessage={setSuccessMessage}
                    parentErrors={errors}
                    parentClearErrors={clearErrors}
                    parentSetValue={setValue}
                  />
                </section>
                <section ref={ol_docref} id="section-5">
                  {/* <OutlookInt
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    getValues={getValues}
                    errors={errors}
                    outlookMisc = {outlookMisc}
                  /> */}
                  {isSave && (
                    <SaveChanges
                      onClose={closeSave}
                      isdirtyFields={isSave}
                      onSave={(e) => {
                        e.preventDefault();
                        handleSubmit(onSubmit)();
                      }}
                    />
                  )}
                </section>
              </div>
            </div>
          </div>
        </MDBCol>
      </div>
      {
        isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                Loading...
              </MDBBtn>
            </div>
          </>
        )
      }
      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}

    </>
  );
}
